import {Box} from 'components/Grid';
import {CalendarSlider} from 'modules/events/components/CalendarSlider';
import {EventsCalendar, IEventsCalendarItem} from 'modules/events/helpers/calendar';
import dayjs from 'dayjs';
import {useRouter} from 'next/router';
import {FC, useCallback, useContext, useMemo} from 'react';
import {EventsListContext} from 'modules/events/context';

interface IQuery {
    date: string;
}

export const Calendar: FC = () => {
    const {meta} = useContext(EventsListContext);

    const router = useRouter();

    const calendar = useMemo(() => {
        const eventsCalendar = new EventsCalendar();

        return eventsCalendar.getCalendar(meta?.calendar);
    }, [meta?.calendar]);

    const handleApplyFilter = useCallback(
        (query: IQuery | null) => {
            const {date, ...restParams} = router.query;

            router.push(
                {
                    pathname: router.pathname,
                    query: {...restParams, ...query},
                },
                undefined,
                {shallow: true},
            );
        },
        [router],
    );

    const activeDayFromUrl = useMemo(() => {
        const {date: dateQuery} = router.query;

        if (!dateQuery) {
            return undefined;
        }

        const [day, month, year] = (dateQuery as string).split('.').map(Number);
        const date = new Date(year, month - 1, day);

        return date.toDateString();
    }, [router.query]);

    const handleSelectDay = useCallback(
        ({dateString}: IEventsCalendarItem) => {
            if (activeDayFromUrl === dateString) {
                handleApplyFilter(null);

                return;
            }

            const newDate = new Date(dateString);
            const formattedDate = dayjs(newDate).format('DD.MM.YYYY');

            handleApplyFilter({
                date: formattedDate,
            });
        },
        [activeDayFromUrl, handleApplyFilter],
    );

    return (
        <Box>
            <CalendarSlider activeDay={activeDayFromUrl} calendar={calendar} onSelectDay={handleSelectDay} />
        </Box>
    );
};
